module.exports = __webpack_public_path__ + "img/box-bg-r.ba707298.png";